import React from "react";
import _ from "underscore";
import $ from "jquery";
import PropTypes from "prop-types";

const propTypes = {
  closeModal: PropTypes.func,
  onClearFilters: PropTypes.func,
  filtersHaveChanged: PropTypes.bool,
};

export default class FilterControls extends React.Component {
  constructor(props) {
    super(props);
    this.className = "filter-controls";
    this.APPLY_CTA = "Apply";
    this.CLOSE_CTA = "Close";
    this.CLEAR_CTA = "Clear";

    this.state = { buttonPosition: this.appleBannerHeight() };

    // listen for the apple banner showing or hiding itself and
    // update positioning of the buttons
    $(window).resize(_.bind(this.setButtonPosition, this));
  }

  setButtonPosition() {
    this.setState({ buttonPosition: this.appleBannerHeight() });
  }

  appleBannerHeight() {
    // oh my god this is horrible. I know no other ways for detecting whether or not
    // the apple smart banner is displaying or not, though...
    var newPosition = $(window).innerHeight() - window.innerHeight;
    return newPosition > 0 ? newPosition : 0;
  }

  componentWillUnmount() {
    $(window).off("resize", this.setButtonPosition);
  }

  renderClearButton() {
    return (
      <a onClick={this.props.onClearFilters} className={`${this.className}__btn btn`}>
        {this.CLEAR_CTA}
      </a>
    );
  }

  renderCloseOrApplyButton() {
    return (
      <a onClick={this.props.closeModal} className={`${this.className}__btn btn`}>
        {this.props.filtersHaveChanged ? this.APPLY_CTA : this.CLOSE_CTA}
      </a>
    );
  }

  render() {
    return (
      <div className={this.className} style={{ bottom: `${this.state.buttonPosition}px` }}>
        {this.renderClearButton()}
        {this.renderCloseOrApplyButton()}
      </div>
    );
  }
}

FilterControls.propTypes = propTypes;
